import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=b10b5c0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b10b5c0a"]])

export default __exports__